import WearMonitoringPanelPage from './WearMonitoringPanelPage';

export default WearMonitoringPanelPage;
